import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { CommandPaletteMode } from '../../../types/spotlight';

interface CommandPaletteState {
  isOpen: boolean;
  mode: CommandPaletteMode;
  openCommandPalette: (mode?: CommandPaletteMode) => void;
  closeCommandPalette: () => void;
  handleOpenChange: (open: boolean) => void;
  setMode: (mode: CommandPaletteMode) => void;
}

const useCommandPaletteStore = create<CommandPaletteState>()(
  devtools((set) => ({
    isOpen: false,
    mode: 'search',
    openCommandPalette: (mode = 'search') => set({ isOpen: true, mode }),
    closeCommandPalette: () => set({ isOpen: false, mode: 'search' }),
    handleOpenChange: (open) => set(open ? { isOpen: true } : { isOpen: false, mode: 'search' }),
    setMode: (mode) => set({ mode })
  }))
);

export { useCommandPaletteStore };
